const routes = [
    {
        name: 'listarClientesParceiro',
        path: '/parceiro/clientes',
        alias: [
            '/parceiro/clientes/index',
            '/contabilidade/clientes',
            '/contabilidade/clientes/index',
        ],
        component: () => import('../views/Listar'),
    },
    {
        name: 'indicarClienteParceiro',
        path: '/parceiro/clientes/adicionar',
        alias: [
            '/contabilidade/clientes/adicionar',
        ],
        component: () => import('../views/Adicionar'),
    },
    {
        name: 'visualizarClienteParceiro',
        path: '/parceiro/clientes/visualizar/:id',
        alias: [
            '/contabilidade/clientes/visualizar/:id'
        ],
        component: () => import('../views/Visualizar'),
    },
]

export default routes
